import { render, staticRenderFns } from "./index.vue?vue&type=template&id=062ce922&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062ce922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062ce922')) {
      api.createRecord('062ce922', component.options)
    } else {
      api.reload('062ce922', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=062ce922&scoped=true", function () {
      api.rerender('062ce922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/com-public/com-yd-table/components/table-column-tip/index.vue"
export default component.exports